import React from "react";

const STATUS_TABS = [
    { key: "all",             label: "All" },
    { key: "needs_attention", label: "Needs Attention" },
    { key: "pending",         label: "Pending" },
    { key: "completed",       label: "Completed" },
    { key: "cancelled",       label: "Cancelled" },
];

const ROLE_OPTIONS = [
    { key: "all",    label: "All" },
    { key: "seller", label: "Selling" },
    { key: "buyer",  label: "Buying" },
];

const OrdersFilterBar = ({
    activeTab,
    onTabChange, 
    roleFilter,
    onRoleChange, 
    counts,
}) => {
    return (
        <div className="orders-filter-bar" data-tutorial="orders-filter-bar">
            <div className="orders-filter-bar__tabs">
                {STATUS_TABS.map((tab) => {
                    const count = counts?.[tab.key] ?? 0;
                    const isActive = activeTab === tab.key;
                    return (
                        <button
                            key={tab.key}
                            className={`orders-tab${isActive ? " orders-tab--active" : ""}${
                                tab.key === "needs_attention" && count > 0 ? " orders-tab--attention" : ""
                            }`}
                            onClick={() => onTabChange(tab.key)}
                        >
                            {tab.label}
                            {count > 0 && (
                                <span className="orders-tab__count">{count}</span>
                            )}
                        </button>
                    );
                })}
            </div>

            <div className="orders-filter-bar__toggles">
                <div className="orders-pill-group">
                    <span className="orders-pill-group__label">Role</span>
                    <div className="orders-pill-group__buttons">
                        {ROLE_OPTIONS.map((opt) => (
                            <button
                                key={opt.key}
                                className={`orders-pill${roleFilter === opt.key ? " orders-pill--active" : ""}`}
                                onClick={() => onRoleChange(opt.key)}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrdersFilterBar;
